import { Form } from 'antd';
import { Textarea } from '@admin-panel/ui';
import { SectionHeading, labelNode } from '../helpers';

type WebsiteContentSectionProps = {
  showHeading: boolean;
  showMetadata: boolean;
  isSectionMode: boolean;
};

const WebsiteContentSection = ({
  showHeading,
  showMetadata,
  isSectionMode,
}: WebsiteContentSectionProps) => {
  if (showMetadata) {
    return (
      <>
        {showHeading ? <SectionHeading title="Website Content" /> : null}
        <Form.Item
          label={labelNode('Look Hook')}
          name="look_hook"
          style={{ marginBottom: 0 }}
        >
          <Textarea rows={3} className="min-h-18" />
        </Form.Item>
        <Form.Item
          label={labelNode('Stylist Note')}
          name={['metadata', 'website_content', 'stylist_note']}
          style={{ marginBottom: 0 }}
        >
          <Textarea rows={5} className="min-h-28" />
        </Form.Item>
        <Form.Item label={labelNode('Blurb')} name="blurb" style={{ marginBottom: 0 }}>
          <Textarea rows={4} className="min-h-24" />
        </Form.Item>
      </>
    );
  }

  return (
    <section className="space-y-3">
      {showHeading ? <SectionHeading title="Website Content" /> : null}
      <Form.Item label={labelNode('Description')} name="description" style={{ marginBottom: 0 }}>
        <Textarea placeholder="Occasion description" rows={4} className="min-h-[96px]" />
      </Form.Item>

      <Form.Item
        label={labelNode('Scene Description')}
        name="scene_description"
        style={{ marginBottom: 0 }}
      >
        <Textarea placeholder="Scene description" rows={4} className="min-h-[96px]" />
      </Form.Item>

      {!isSectionMode ? (
        <Form.Item
          label={labelNode('Layering Type')}
          name="layering_type"
          style={{ marginBottom: 0 }}
        >
          <Textarea placeholder="Layering type" disabled rows={1} className="min-h-10" />
        </Form.Item>
      ) : null}
    </section>
  );
};

export default WebsiteContentSection;
